import React, {Fragment} from 'react';
import { withAuth } from '@okta/okta-react';
import {
    DropdownToggle, DropdownMenu,
    Nav,  NavItem, NavLink,
     UncontrolledButtonDropdown
} from 'reactstrap';
import {
    toast,
    Bounce
} from 'react-toastify';


import {
    
    faAngleDown

} from '@fortawesome/free-solid-svg-icons';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class UserBox extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
        // this.state = {
        //     active: false,
        // };

    }
    async logout() {
      let rn_flag = localStorage.getItem("showReleaseNotes");
      localStorage.clear();
      this.props.auth.logout('/');
      if(rn_flag === 'false'){
        console.log("Don't show release notes enabled. ")
        localStorage.setItem("showReleaseNotes", rn_flag);
      }      
  }


    notify2 = () => this.toastId = toast("You don't have any new items in your calendar for today! Go out and play!", {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: 'bottom-center',
        type: 'success'
    });




    render() {
      let that = this;
      function handleLogout(e) {
        that.logout();
         
        }

        function handleHelp() {
            alert('Please contact your supplier engineer');
        }

        return (
            <Fragment>
                <div className="header-btn-lg pr-0" >
                    <div className="widget-content p-0">
                        <div className="widget-content-wrapper">


                            <div className="widget-content-left">
                                <UncontrolledButtonDropdown>
                                    <DropdownToggle color="link" className="p-0">
                                    <div className="widget-content-left  ml-3 header-user-info">
                                        <div className="widget-heading">
                                            {JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name}
                                              <FontAwesomeIcon className="ml-2 opacity-8" icon={faAngleDown}/>
                                        </div>

                                    </div>

                                    </DropdownToggle>
                                    <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                                        <Nav vertical>

                                            <NavItem className="nav-item-header">
                                                My Account
                                            </NavItem>
                                            <NavItem>
                                                <NavLink onClick={handleHelp}>
                                                    HelpNow
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink onClick={handleLogout}>
                                                    Logout

                                                </NavLink>
                                            </NavItem>

                                        </Nav>
                                    </DropdownMenu>
                                </UncontrolledButtonDropdown>
                            </div>


                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default withAuth(UserBox);
